import { createToast } from "./features/createToast"
import { successElement } from "./utils/successElement"

export default () => {

    /**
     * Create a toast
     * 1. Add an HTML element with an `id` or use the `toast-btn` class.
     * 2. Define corresponding toast params in `./utils/toastParams.ts`.
    */

    const containerToast = document.querySelector('.container-toast') as HTMLSpanElement

    // Affichage Toast lorsqu'un élément est visible (Refresh page formulaire)
    successElement.forEach((el) => {
        el && createToast(el.id, containerToast)
    })


    // Affichage d'un Toast au clic sur bouton
    const btns = document.querySelectorAll('.toast-btn') as NodeListOf<HTMLButtonElement>
    btns.forEach((btn) => {
        containerToast && (btn.addEventListener('click', () => createToast(btn.id, containerToast)))
    })
}
